export default __webpack_public_path__ + "static/media/Boots of Writhing.c3a3063c.jpg";